<div class="form">
  <div class="section" [formGroup]="SMPTSettingsGroup">
    <h3 class="section-title">SMTP (Sending emails)</h3>

    @if (SMPTSettingsGroup.get('fromName'); as fromName) {
      <div class="col2-layout">
        <label class="col1 label">From name:</label>
        <input class="col2" type="text" placeholder="Enter your name" formControlName="fromName" />
        @if (fromName.touched) {
          <div class="validation-message">
            @if (fromName.errors?.required) {
              <div>Name required</div>
            }
            @if (fromName.errors?.maxlength) {
              <div>Max length for name is 50</div>
            }
          </div>
        }
      </div>
    }
    @if (SMPTSettingsGroup.get('fromEmail'); as fromEmail) {
      <div class="col2-layout from-email-section">
        <label class="col1 label">From email:</label>
        <input
          class="col2"
          type="text"
          placeholder="Enter your email"
          formControlName="fromEmail" />
        @if (fromEmail.touched && fromEmail.invalid) {
          <div class="validation-message">
            @if (fromEmail.errors?.required) {
              From email required.
            } @else {
              From email invalid.
            }
          </div>
        }
      </div>
    }

    <div id="alt-account-name-checkbox" class="col2-layout">
      <div class="col2">
        <label class="checkbox-label-group" (click)="(null)">
          <input type="checkbox" #diffAccountNameCheckbox formControlName="useDiffAccountName" />

          <app-campaign-checkbox
            [checked]="diffAccountNameCheckbox.checked"></app-campaign-checkbox>

          <span>Use different account name</span>
        </label>
      </div>
    </div>

    @if (SMPTSettingsGroup.get('alternativeUsername'); as alternativeUsername) {
      <div
        class="col2-layout"
        [class.hidden]="!SMPTSettingsGroup?.get('useDiffAccountName')?.value">
        <label class="col1 label">User name:</label>
        <input
          class="col2"
          type="text"
          placeholder="Enter user name"
          formControlName="alternativeUsername" />
        @if (alternativeUsername.touched && alternativeUsername.invalid) {
          <div class="validation-message">Alternative user name required</div>
        }
      </div>
    }
    @if (SMPTSettingsGroup.get('appPassword'); as appPassword) {
      <div class="col2-layout">
        <label class="col1 label">App password:</label>
        <input
          class="col2"
          type="text"
          placeholder="Enter app password"
          formControlName="appPassword" />
        @if (appPassword.touched && appPassword.invalid) {
          <div class="validation-message">
            @if (appPassword.errors?.required) {
              Password is required
            } @else {
              Password is invalid
            }
          </div>
        }
      </div>
    }
    @if (SMPTSettingsGroup.get('host'); as host) {
      <div class="col2-layout">
        <label class="col1 label">Host:</label>
        <input class="col2" type="text" placeholder="Enter host" formControlName="host" />
        @if (host.touched && host.invalid) {
          <div class="validation-message">
            @if (host.errors?.required) {
              Host address required
            } @else {
              Host address invalid
            }
          </div>
        }
      </div>
    }
    @if (SMPTSettingsGroup.get('port'); as port) {
      <div class="col2-layout">
        <label class="col1 label">Port:</label>
        <input
          class="col2"
          type="number"
          min="0"
          max="65535"
          placeholder="Enter port"
          formControlName="port" />
        @if (port.touched && port.invalid) {
          <div class="validation-message">
            @if (port.errors?.required) {
              Port number required.
            } @else {
              Port invalid.
            }
          </div>
        }
      </div>
    }

    <div class="radio-group">
      <label class="radio-item" (click)="(null)">
        <input
          #sendEncriptionSSL
          type="radio"
          name="send-encription"
          formControlName="smtpEncriptionProtocol"
          value="SSL" />

        <app-radio [checked]="sendEncriptionSSL.checked"></app-radio>

        <span>SSL</span>
      </label>

      <label class="radio-item" (click)="(null)">
        <input
          type="radio"
          name="send-encription"
          #sendEnctiptionTLS
          formControlName="smtpEncriptionProtocol"
          value="TLS" />

        <app-radio [checked]="sendEnctiptionTLS.checked"></app-radio>

        <span>TLS</span>
      </label>

      <label class="radio-item" (click)="(null)">
        <input
          #sendEnctiptionNone
          type="radio"
          name="send-encription"
          formControlName="smtpEncriptionProtocol"
          value="NONE" />

        <app-radio [checked]="sendEnctiptionNone.checked"></app-radio>

        <span>None</span>
      </label>
    </div>

    <div class="col1-layout">
      <label class="checkbox-label-group" (click)="(null)">
        <input type="checkbox" #diffReplayAddressCheckbox formControlName="useDiffReplayAddress" />

        <app-campaign-checkbox
          [checked]="diffReplayAddressCheckbox.checked"></app-campaign-checkbox>

        <span>Set a different reply-to address</span>
      </label>
    </div>

    @if (SMPTSettingsGroup?.get('alternativeReplayAddress'); as alternativeReplayAddress) {
      <div
        class="col2-layout"
        [class.hidden]="!SMPTSettingsGroup.get('useDiffReplayAddress')?.value">
        <label class="col1 label">Reply to:</label>
        <input
          class="col2"
          type="text"
          placeholder="Enter host"
          formControlName="alternativeReplayAddress" />
        @if (alternativeReplayAddress.touched && alternativeReplayAddress.invalid) {
          <div class="validation-message">
            @if (alternativeReplayAddress.errors?.required) {
              Replay address required
            } @else {
              Replay address invalid.
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="selction" [formGroup]="IMAPSettingsGroup">
    <h3 class="section-title">IMAP (Receiving emails)</h3>

    <div class="col1-layout">
      <label class="checkbox-label-group" (click)="(null)">
        <input
          type="checkbox"
          #receiveFromOtherEmailsCheckbox
          formControlName="receiveResponceOnDiffEmail" />

        <app-campaign-checkbox
          [checked]="receiveFromOtherEmailsCheckbox.checked"></app-campaign-checkbox>

        <span>I receive replies to an email account thats not my from email</span>
      </label>
    </div>

    @if (IMAPSettingsGroup.get('imapUserName'); as imapUserName) {
      <div
        class="col2-layout"
        [class.hidden]="!IMAPSettingsGroup?.get('receiveResponceOnDiffEmail')?.value">
        <label class="col1 label">User name:</label>
        <input class="col2" type="text" placeholder="Enter host" formControlName="imapUserName" />
        @if (imapUserName.touched && imapUserName.invalid) {
          <div class="validation-message">Fill username.</div>
        }
      </div>
    }
    @if (IMAPSettingsGroup.get('imapPassword'); as imapPassword) {
      <div
        class="col2-layout"
        [class.hidden]="!IMAPSettingsGroup?.get('receiveResponceOnDiffEmail')?.value">
        <label class="col1 label">Password:</label>
        <input class="col2" type="text" placeholder="Enter host" formControlName="imapPassword" />
        @if (imapPassword.touched && imapPassword.invalid) {
          <div class="validation-message">
            @if (imapPassword.errors?.required) {
              Fill password.
            } @else {
              Password invalid.
            }
          </div>
        }
      </div>
    }
    @if (IMAPSettingsGroup.get('host'); as host) {
      <div class="col2-layout">
        <label class="col1 label">Host:</label>
        <input class="col2" type="text" placeholder="Enter host" formControlName="host" />
        @if (host.touched && host.invalid) {
          <div class="validation-message">
            @if (host.errors?.required) {
              Host required
            } @else {
              Host address invalid
            }
          </div>
        }
      </div>
    }
    @if (IMAPSettingsGroup.get('port'); as port) {
      <div class="col2-layout">
        <label class="col1 label">Port:</label>
        <input
          class="col2"
          type="number"
          min="0"
          max="65535"
          placeholder="Enter port"
          formControlName="port" />
        @if (port.touched && port.invalid) {
          <div class="validation-message">
            @if (port.errors?.required) {
              Port number required.
            } @else {
              Port invalid.
            }
          </div>
        }
      </div>
    }

    <div class="radio-group">
      <label class="radio-item" (click)="(null)">
        <input
          type="radio"
          name="receive-encription"
          #receiveEncriptionSSL
          formControlName="imapEncryptionProtocol"
          value="SSL" />

        <app-radio [checked]="receiveEncriptionSSL.checked"></app-radio>

        <span>SSL</span>
      </label>

      <label class="radio-item" (click)="(null)">
        <input
          type="radio"
          name="receive-encription"
          #receiveEnctiptionTLS
          formControlName="imapEncryptionProtocol"
          value="TLS" />

        <app-radio [checked]="receiveEnctiptionTLS.checked"></app-radio>

        <span>TLS</span>
      </label>

      <label class="radio-item" (click)="(null)">
        <input
          type="radio"
          name="receive-encription"
          #receiveEnctiptionNone
          formControlName="imapEncryptionProtocol"
          value="NONE" />

        <app-radio [checked]="receiveEnctiptionNone.checked"></app-radio>

        <span>None</span>
      </label>
    </div>
  </div>
</div>

@if ($connectionVerificationStatus | async; as status) {
  <div class="connection-test-wrapper">
    <div class="info">
      @if (status === 'failed') {
        <div class="info-wrapper info-red">
          <svg class="icon">
            <use xlink:href="#red-sign-with-minus"></use>
          </svg>
          <div class="info-message">Connection to your email account has failed</div>
        </div>
      }
      @if (status === 'ok') {
        <div class="info-wrapper info-green">
          <svg class="icon">
            <use xlink:href="#green-sign-with-check"></use>
          </svg>
          <div class="info-message">Connection to your email account is good</div>
        </div>
      }
    </div>
    <div class="action" [class.loading]="status === 'loading'">
      <button class="btn" (click)="verifyConnection()" [disabled]="$formInvalid | async">
        Check connection
      </button>
      <div class="loading-animation">
        <app-loading-animation></app-loading-animation>
      </div>
    </div>
  </div>
}
